@if (shouldShowError() || shouldShowCharacterCount()) {
  <div class="error-container" role="alert" [attr.aria-live]="'polite'">
    <div class="error-inline">
      <!-- Error message section (left side) -->
      @if (shouldShowError()) {
        @if (showIcon()) {
          <span class="fa fa-exclamation-circle error-icon" aria-hidden="true">!</span>
        }
        <span class="error-text">{{ errorMessage() }}</span>
      }
      
      <!-- Character count section (right side) -->
      @if (shouldShowCharacterCount()) {
        <div class="character-count" [class.over-limit]="isOverLimit()">
          {{ compactCharacterText() }}
        </div>
      }
    </div>
  </div>
}
